import { render, staticRenderFns } from "./StudyInputFile.vue?vue&type=template&id=4e4e86d2&"
import script from "./StudyInputFile.vue?vue&type=script&lang=js&"
export * from "./StudyInputFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports